// src/components/2257.js
import styled from "styled-components";
import { Link } from "react-router-dom";

const Statement2257 = () => {
  return (
    <Wrap>
      <Inner>
        <Top>
          <H1>18 U.S.C. 2257 Record Keeping Compliance Statement</H1>
          <Meta>
            Catching Gold Diggers
            <Dot>•</Dot>
            Last updated: <strong>[2026]</strong>
          </Meta>

          <Intro>
            This statement is provided to comply with the record keeping requirements of 18 U.S.C.
            § 2257 and 28 C.F.R. Part 75.
          </Intro>
        </Top>

        <Section>
          <H2>Age Verification</H2>
          <P>
            All models, actors, actresses, and other persons who appear in any visual depiction of
            actual sexually explicit conduct appearing or otherwise contained on this website were
            at least eighteen (18) years of age at the time of the creation of such depictions.
          </P>
          <P>
            With respect to all visual depictions displayed on this website, whether of actual
            sexually explicit conduct, simulated sexual content, or otherwise, all persons in said
            visual depictions were at least eighteen (18) years of age when said visual depictions
            were created.
          </P>
        </Section>

        <Section>
          <H2>Primary Producer Status</H2>
          <P>
            The owners and operators of Catching Gold Diggers are the <strong>primary producer</strong>{" "}
            (as defined in 18 U.S.C. § 2257) of the visual content contained on this website.
          </P>
        </Section>

        <Section>
          <H2>Custodian of Records</H2>
          <P>
            The records required pursuant to 18 U.S.C. § 2257 and 28 C.F.R. Part 75 for all
            materials contained on this website are maintained by the Custodian of Records listed
            below.
          </P>

          <Callout>
            <CalloutTitle>Custodian of Records</CalloutTitle>
            <CalloutText>
              <strong>[Custodian name or company]</strong>
              <br />
              <strong>[Street address]</strong>
              <br />
              <strong>[City]</strong>, <strong>[Postcode]</strong>
              <br />
              <strong>United Kingdom</strong>
            </CalloutText>
          </Callout>

          <P>
            This contact information is provided for 2257 record keeping compliance requests only
            and is not intended for general customer support.
          </P>
        </Section>

        <Section>
          <H2>Legal Contact</H2>
          <P>
            Please direct legal questions pertaining to content on this website to:{" "}
            <strong>[legal@catchinggolddiggers.com]</strong>
          </P>
        </Section>

        <BottomNav>
          <BackLink to="/">Back to Home</BackLink>
        </BottomNav>
      </Inner>
    </Wrap>
  );
};

export default Statement2257;

/* ---------- styles ---------- */

const Wrap = styled.div`
  background: #000;
  color: #fff;
  min-height: 100vh;
  padding: 60px 0;
`;

const Inner = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 0 80px;

  @media (max-width: 868px) {
    padding: 0 35px;
  }

  @media (max-width: 568px) {
    padding: 0 20px;
  }
`;

const Top = styled.div`
  margin-bottom: 26px;
`;

const H1 = styled.h1`
  margin: 0 0 10px;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: -0.4px;

  @media (max-width: 568px) {
    font-size: 28px;
  }
`;

const Meta = styled.div`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
`;

const Dot = styled.span`
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.35);
`;

const Intro = styled.p`
  margin: 14px 0 0;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
`;

const Section = styled.section`
  scroll-margin-top: 110px;
  margin-top: 26px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
`;

const H2 = styled.h2`
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 800;
`;

const P = styled.p`
  margin: 0 0 10px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.78);
`;

const Callout = styled.div`
  margin: 14px 0 12px;
  padding: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
`;

const CalloutTitle = styled.div`
  font-size: 13px;
  font-weight: 800;
  margin-bottom: 6px;
  color: rgba(255, 255, 255, 0.92);
`;

const CalloutText = styled.div`
  font-size: 13px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.78);
`;

const BottomNav = styled.div`
  margin-top: 34px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  justify-content: flex-start;
`;

const BackLink = styled(Link)`
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
  font-weight: 700;

  &:hover {
    text-decoration: underline;
  }
`;
